import { useEffect } from 'react';
import { BannerTypes } from '@gin-betting/banners';

import useBanners from '../Banners/useBanners';

interface Input {
    zoneId: string;
}

interface Output {
    filteredBanners: BannerTypes.BannerItem[];
    interval: number;
}

const useColorfulBanners = ({ zoneId }: Input): Output => {
    const { banners, interval } = useBanners({ zoneId });
    const filteredBanners = banners.filter(({ id }) => id);

    const bannersSize = filteredBanners.length;

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--colorful-banner-height',
            bannersSize > 0 ? '140px' : '0px'
        );

        return () => {
            document.documentElement.style.setProperty(
                '--colorful-banner-height',
                '0px'
            );
        };
    }, [bannersSize]);

    return {
        filteredBanners,
        interval,
    };
};

export default useColorfulBanners;
